module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA6klEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBevBp+P///9+/f4EkUMN/GABKG87aKde1RK2gRalnuf7sXQgNQHVQJCcHZwOlhRbsZeld6hThJ9HUIbDoIEIDxNEIJ61Y0du/FygtMXcX27LjtlVpKotni8zdh2TD9Ol+hTvgGqq79kM8zbfwsNCibY5F9gyT6oQWn0BoALKwoqzinJIoY6NocZ0c7cL8XAIamE1mtJV2rFJn8A1li/Bj7SzqJGwDv/286opp05OCqmrn8tnNQ9NAGJGlYVACAGdVwS2706YtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MS.png
// module id = 1215
// module chunks = 0